import styled from "styled-components";

export const Styles = styled.div`
  &.disable {
    .ant-form-item-control {
      display: none;
    }
    .value_text_container {
      border: 1px solid #d9d9d9;
      height: 44px;
      padding: 10px;
      background: #f5f5f5;
      border-radius: 4px;
      a {
        text-wrap-mode: nowrap;
      }
      &.table {
        border: unset;
        height: unset;
        padding: 0;
        background: unset;
        border-radius: 4unset;
      }
    }
  }
`;
